import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { getRelatedFormsySubmissions, getADUsers } from "./../services/soar";
import { deactivateShared, deactivateForm } from "./supervisionScripts";
import NewSupervisionModal from "./NewSupervisionModal";
import ExpandDiv from "../common/ExpandDiv";
import ShareModal from "./ShareModal";
import Input from "../common/Input";
import SearchBox from "../common/SearchBox";
import SearchAndSelect from "../common/SearchAndSelect";

function Supervision2() {
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const [safyUsers, setSafyUsers] = useState([]);
  const [selectedLogs, setSelectedLogs] = useState([]);
  const [relatedSubmissions, setRelatedSubmissions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [searchData, setSearchData] = useState({});
  const [providerSearch, setProviderSearch] = useState("");

  useEffect(() => {
    const environmentApplicationId =
      process.env.REACT_APP_ENVIRONMENT === "Production"
        ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
        : "58990f83-8566-4ba8-b4b5-584a64e4cba1";
    getRelatedFormsySubmissions(
      [
        "A51B13BE-6B02-EF11-8076-DC98408D5418",
        "E2DD0183-5809-EF11-8076-0050F21C653C",
      ],
      providerSearch !== "" ? providerSearch : safyInfo.user.azureId
    ).then((response) => {
      let primary = [];
      let seconday = [];
      let shared = [];

      response.data.forEach((r) => {
        if (r.Primary)
          primary.push(
            ...r.Primary.filter(
              (x) =>
                x.ApplicationId.toUpperCase() ===
                environmentApplicationId.toUpperCase()
            )
          );
        if (r.Secondary)
          seconday.push(
            ...r.Secondary.filter(
              (x) =>
                x.ApplicationId.toUpperCase() ===
                environmentApplicationId.toUpperCase()
            )
          );
        if (r.Shared)
          shared.push(
            ...r.Shared.filter(
              (x) =>
                x.ApplicationId.toUpperCase() ===
                environmentApplicationId.toUpperCase()
            )
          );
      });

      setRelatedSubmissions({
        Primary: primary.sort(
          (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn)
        ),
        Secondary: seconday.sort(
          (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn)
        ),
        Shared: shared.sort(
          (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn)
        ),
      });
      setRefreshData(false);
      return response;
    });
  }, [refreshData]);

  useEffect(() => {
    const loadUsers = async () => {
      let response = await getADUsers();
      if (!response) {
        return;
      }

      if (process.env.REACT_APP_ENVIRONMENT === "Production") {
        response = response.filter(
          (u) => u.internalemailaddress !== safyInfo.user.email
        );
      }

      const users = response
        .filter((u) => u.internalemailaddress)
        .map((u) => ({
          key: u.internalemailaddress,
          _id: u.internalemailaddress.toLowerCase(),
          name: `${u.fullname}`,
          firstLast: `${u.firstname} ${u.lastname}`,
          azureid: u.azureid,
        }));
      setSafyUsers(users);
    };

    loadUsers();
  }, []);

  const handleProviderSearch = ({ currentTarget: input }) => {
    setProviderSearch(input.value);
  };

  const handleDataChange = ({ currentTarget: input }) => {
    const obj = { ...searchData };
    obj[input.name] = input.type === "checkbox" ? input.checked : input.value;
    setSearchData(obj);
  };

  const addOrRemoveSelectedLogs = (submissionId) => {
    const obj = [...selectedLogs];
    const exists = obj.includes(submissionId);
    if (exists) {
      obj.splice(obj.indexOf(submissionId), 1);
    } else {
      obj.push(submissionId);
    }
    setSelectedLogs(obj);
  };

  const clearShareWith = async (submissionId) => {
    await deactivateShared(submissionId);
    handleClose();
  };

  const handleClose = () => {
    setIsOpen(false);
    setRefreshData(true);
    setSelectedLogs([]);
  };

  return (
    <div className="mb-4">
      <ShareModal
        isOpen={isOpen}
        handleClose={handleClose}
        submissionData={selectedLogs.map((i) => ({ SubmissionId: i }))}
      />
      {safyInfo.user.modules.includes("Admin") ? (
        <div className="rounded bg-warning p-2 mb-4">
          <div className="fw-bold">This section visible to Admins ONLY</div>
          <div className="row mt-4">
            <div className="col-md-10 col-lg-11 mb-2 mb-md-0">
              <SearchAndSelect
                label="Search by Provider Name"
                options={safyUsers}
                setSelected={(selected) => {
                  setProviderSearch(selected.azureid);
                  setRefreshData(true);
                }}
              />
            </div>
            <div className="col-md-2 col-lg-1 d-flex align-items-center justify-content-center">
              <i
                className="fas fa-times-circle fa-2x text-danger"
                role="button"
                onClick={() => {
                  setProviderSearch("");
                  setRefreshData(true);
                }}
              />
            </div>
          </div>
        </div>
      ) : null}
      <div className="row mt-2">
        <div className="col-md-6 col-lg-6 mb-3">
          <SearchBox
            name="mySearchQuery"
            label="Search by Supervisee Name"
            value={searchData.mySearchQuery}
            onChange={handleDataChange}
            clearSearch={() => {
              const obj = { ...searchData };
              obj.mySearchQuery = "";
              setSearchData(obj);
            }}
          />
        </div>
        <div className="col-md-3 col-lg-3 mb-3">
          <Input
            name="myBeginDate"
            type="date"
            label="Begin Date"
            value={searchData.myBeginDate}
            onChange={handleDataChange}
          />
        </div>
        <div className="col-md-3 col-lg-3 mb-3">
          <Input
            name="myEndDate"
            type="date"
            label="End Date"
            value={searchData.myEndDate}
            onChange={handleDataChange}
          />
        </div>
      </div>
      <div className="row my-2">
        <div className="col-8 my-2">
          {selectedLogs.length > 0 ? (
            <div className="btn btn-danger" onClick={() => setIsOpen(true)}>
              Share With
            </div>
          ) : null}
        </div>

        <div className="col-4 d-flex justify-content-end gap-2">
          <Link title="Supervision 1.0 Logs" to={`/supervision`}>
            <div className="btn btn-secondary">1.0 Logs</div>
          </Link>
          <NewSupervisionModal
            safyUsers={safyUsers}
            refreshData={() => setRefreshData(true)}
          />
        </div>
      </div>
      {relatedSubmissions?.Primary && (
        <ExpandDiv
          className="bg-safy3-1 text-white p-2 mb-4"
          title="You are the Supervisee"
          expandIcon="fas fa-chevron-down text-white"
          collapseIcon="fas fa-chevron-up text-white"
        >
          <div className="bg-safy3-1 text-white">
            <div className="row">
              <div className="col fw-bold">Supervisee</div>
              <div className="col fw-bold">Supervisor</div>
              <div className="col fw-bold">Type</div>
              <div className="col fw-bold">Date</div>
              <div className="col fw-bold">Actions</div>
            </div>
          </div>
          <div className="bg-white py-2">
            {relatedSubmissions.Primary.filter(
              (p) =>
                (p.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418" &&
                  p.FormLocked === true) ||
                p.ContainerId === "E2DD0183-5809-EF11-8076-0050F21C653C"
            )
              .filter(
                (f) =>
                  f.SecondaryObjectName.toUpperCase().includes(
                    searchData?.mySearchQuery?.toUpperCase() || ""
                  ) &&
                  (searchData.myBeginDate
                    ? new Date(f.Compliancy?.date) >=
                      new Date(searchData?.myBeginDate)
                    : true) &&
                  (searchData.myEndDate
                    ? new Date(f.Compliancy?.date) <=
                      new Date(searchData?.myEndDate)
                    : true)
              )
              .map((p) => (
                <div
                  key={`pri-${p.SubmissionId}`}
                  className={`rounded row bg-light text-dark m-0 ${
                    selectedLogs.includes(p.SubmissionId)
                      ? "border border-danger"
                      : ""
                  }`}
                >
                  <div className="col">
                    {p.PrimaryObjectName}
                    {p.Related?.filter(
                      (r) =>
                        r.ObjectType === "Signature" &&
                        r.ObjectJSON.role === "Supervisee" &&
                        r.ObjectJSON.azureId.toUpperCase() ===
                          p.PrimaryObjectId.toUpperCase()
                    ).length > 0 ? (
                      <div
                        className="fas fa-signature text-success ms-1"
                        title="signed"
                      ></div>
                    ) : null}
                  </div>
                  <div className="col">
                    {p.SecondaryObjectName}
                    {p.Related?.filter(
                      (r) =>
                        r.ObjectType === "Signature" &&
                        r.ObjectJSON.role === "Supervisor" &&
                        r.ObjectJSON.azureId.toUpperCase() ===
                          p.SecondaryObjectId.toUpperCase()
                    ).length > 0 ? (
                      <div
                        className="fas fa-signature text-success ms-1"
                        title="signed"
                      ></div>
                    ) : null}
                  </div>
                  <div className="col">
                    {p.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
                      ? "Individual Supervision"
                      : "Group Supervision"}
                  </div>
                  <div className="col">
                    {p.Compliancy?.date
                      ? moment(p.Compliancy?.date).format("MM/DD/YYYY")
                      : ""}
                  </div>
                  <div className="col">
                    <Link
                      title="Supervision Log"
                      to={`/supervision/${
                        p.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
                          ? "individual"
                          : "group"
                      }/${p.SubmissionId}`}
                    >
                      <i
                        className="fas fa-edit text-primary me-2 fa-lg"
                        title="Edit"
                        role="button"
                      ></i>
                    </Link>
                    <i
                      className="fas fa-share text-warning me-2 fa-lg"
                      title={
                        p.Related &&
                        p.Related.filter((l) => l.ObjectType === "Shared")
                          .length > 0
                          ? `Shared with ${p.Related.filter(
                              (l) => l.ObjectType === "Shared"
                            ).map((x) => x.ObjectJSON.name)}`
                          : "Not Shared With Anyone Else"
                      }
                      role="button"
                      onClick={() => addOrRemoveSelectedLogs(p.SubmissionId)}
                    ></i>
                    {safyInfo.user.modules.includes("Admin") && (
                      <i
                        className="fas fa-trash-can text-secondary me-2 fa-lg"
                        title="Admin Delete"
                        role="button"
                        onClick={() =>
                          deactivateForm(p.SubmissionId, handleClose)
                        }
                      ></i>
                    )}
                    {p.FormLocked === false &&
                      p.CreatedById.toUpperCase() ===
                        safyInfo.user.azureId.toUpperCase() && (
                        <i
                          className="fas fa-trash text-danger me-2 fa-lg"
                          title="Delete"
                          role="button"
                          onClick={() =>
                            deactivateForm(p.SubmissionId, handleClose)
                          }
                        ></i>
                      )}
                  </div>
                </div>
              ))}
          </div>
        </ExpandDiv>
      )}
      {relatedSubmissions?.Secondary && (
        <ExpandDiv
          className="bg-primary text-white p-2 mb-4"
          title="You are the Supervisor"
          expandIcon="fas fa-chevron-down text-white"
          collapseIcon="fas fa-chevron-up text-white"
        >
          <div className="bg-primary text-white">
            <div className="row">
              <div className="col fw-bold">Supervisee</div>
              <div className="col fw-bold">Supervisor</div>
              <div className="col fw-bold">Type</div>
              <div className="col fw-bold">Date</div>
              <div className="col fw-bold">Actions</div>
            </div>
          </div>
          <div className="bg-white py-2">
            {relatedSubmissions.Secondary.filter(
              (p) =>
                p.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418" ||
                (p.FormLocked === true &&
                  p.ContainerId === "E2DD0183-5809-EF11-8076-0050F21C653C")
            )
              .filter(
                (f) =>
                  f.PrimaryObjectName.toUpperCase().includes(
                    searchData?.mySearchQuery?.toUpperCase() || ""
                  ) &&
                  (searchData.myBeginDate
                    ? new Date(f.Compliancy?.date) >=
                      new Date(searchData?.myBeginDate)
                    : true) &&
                  (searchData.myEndDate
                    ? new Date(f.Compliancy?.date) <=
                      new Date(searchData?.myEndDate)
                    : true)
              )
              .map((s) => (
                <div
                  key={`sec-${s.SubmissionId}`}
                  className={`rounded row bg-light text-dark m-0 ${
                    selectedLogs.includes(s.SubmissionId)
                      ? "border border-danger"
                      : ""
                  }`}
                >
                  <div className="col">
                    {s.PrimaryObjectName}
                    {s.Related?.filter(
                      (r) =>
                        r.ObjectType === "Signature" &&
                        r.ObjectJSON.role === "Supervisee" &&
                        r.ObjectJSON.azureId.toUpperCase() ===
                          s.PrimaryObjectId.toUpperCase()
                    ).length > 0 ? (
                      <div
                        className="fas fa-signature text-success ms-1"
                        title="signed"
                      ></div>
                    ) : null}
                  </div>
                  <div className="col">
                    {s.SecondaryObjectName}
                    {s.Related?.filter(
                      (r) =>
                        r.ObjectType === "Signature" &&
                        r.ObjectJSON.role === "Supervisor" &&
                        r.ObjectJSON.azureId.toUpperCase() ===
                          s.SecondaryObjectId.toUpperCase()
                    ).length > 0 ? (
                      <div
                        className="fas fa-signature text-success ms-1"
                        title="signed"
                      ></div>
                    ) : null}
                  </div>
                  <div className="col">
                    {s.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
                      ? "Individual Supervision"
                      : "Group Supervision"}
                  </div>
                  <div className="col">
                    {s.Compliancy?.date
                      ? moment(s.Compliancy?.date).format("MM/DD/YYYY")
                      : ""}
                  </div>
                  <div className="col">
                    <Link
                      title="Supervision Log"
                      to={`/supervision/${
                        s.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
                          ? "individual"
                          : "group"
                      }/${s.SubmissionId}`}
                    >
                      <i
                        className="fas fa-edit text-primary me-2 fa-lg"
                        title="Edit"
                        role="button"
                      />
                    </Link>
                    <i
                      className="fas fa-share text-warning me-2 fa-lg"
                      title={
                        s.Related &&
                        s.Related.filter((l) => l.ObjectType === "Shared")
                          .length > 0
                          ? `Shared with ${s.Related.filter(
                              (l) => l.ObjectType === "Shared"
                            ).map((x) => x.ObjectJSON.name)}`
                          : "Not Shared With Anyone Else"
                      }
                      role="button"
                      onClick={() => addOrRemoveSelectedLogs(s.SubmissionId)}
                    ></i>
                    {safyInfo.user.modules.includes("Admin") && (
                      <i
                        className="fas fa-trash-can text-secondary me-2 fa-lg"
                        title="Admin Delete"
                        role="button"
                        onClick={() =>
                          deactivateForm(s.SubmissionId, handleClose)
                        }
                      ></i>
                    )}
                    {s.FormLocked === false &&
                      s.CreatedById.toUpperCase() ===
                        safyInfo.user.azureId.toUpperCase() && (
                        <i
                          className="fas fa-trash text-danger me-2 fa-lg"
                          title="Delete"
                          role="button"
                          onClick={() =>
                            deactivateForm(s.SubmissionId, handleClose)
                          }
                        />
                      )}
                  </div>
                </div>
              ))}
          </div>
        </ExpandDiv>
      )}
      {relatedSubmissions?.Shared && (
        <ExpandDiv
          className="bg-info text-white p-2 mb-4"
          title="Shared With You"
          expandIcon="fas fa-chevron-down text-white"
          collapseIcon="fas fa-chevron-up text-white"
        >
          <div className="bg-info text-white">
            <div className="row">
              <div className="col fw-bold">Supervisee</div>
              <div className="col fw-bold">Supervisor</div>
              <div className="col fw-bold">Type</div>
              <div className="col fw-bold">Date</div>
              <div className="col fw-bold">Actions</div>
            </div>
          </div>
          <div className="bg-white py-2">
            {relatedSubmissions.Shared.filter(
              (f) =>
                (searchData.mySearchQuery
                  ? f.PrimaryObjectName.toUpperCase().includes(
                      searchData?.mySearchQuery?.toUpperCase()
                    ) ||
                    f.SecondaryObjectName.toUpperCase().includes(
                      searchData?.mySearchQuery?.toUpperCase()
                    )
                  : true) &&
                (searchData.myBeginDate
                  ? new Date(f.Compliancy?.date) >=
                    new Date(searchData?.myBeginDate)
                  : true) &&
                (searchData.myEndDate
                  ? new Date(f.Compliancy?.date) <=
                    new Date(searchData?.myEndDate)
                  : true)
            ).map((x) => {
              return (
                <div
                  key={`ter-${x.SubmissionId}`}
                  className={`rounded row bg-light text-dark m-0 ${
                    selectedLogs.includes(x.SubmissionId)
                      ? "border border-danger"
                      : ""
                  }`}
                >
                  <div className="col">
                    {x.PrimaryObjectName}
                    {x.Related?.filter(
                      (r) =>
                        r.ObjectType === "Signature" &&
                        r.ObjectJSON.role === "Supervisee" &&
                        r.ObjectJSON.azureId.toUpperCase() ===
                          x.PrimaryObjectId.toUpperCase()
                    ).length > 0 ? (
                      <div
                        className="fas fa-signature text-success ms-1"
                        title="signed"
                      ></div>
                    ) : null}
                  </div>
                  <div className="col">
                    {x.SecondaryObjectName}
                    {x.Related?.filter(
                      (r) =>
                        r.ObjectType === "Signature" &&
                        r.ObjectJSON.role === "Supervisor" &&
                        r.ObjectJSON.azureId.toUpperCase() ===
                          x.SecondaryObjectId.toUpperCase()
                    ).length > 0 ? (
                      <div
                        className="fas fa-signature text-success ms-1"
                        title="signed"
                      ></div>
                    ) : null}
                  </div>
                  <div className="col">
                    {x.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
                      ? "Individual Supervision"
                      : "Group Supervision"}
                  </div>
                  <div className="col">
                    {x.Compliancy?.date
                      ? moment(x.Compliancy?.date).format("MM/DD/YYYY")
                      : ""}
                  </div>
                  <div className="col">
                    <Link
                      title="Supervision Log"
                      to={`/supervision/${
                        x.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
                          ? "individual"
                          : "group"
                      }/${x.SubmissionId}`}
                    >
                      <i
                        className="fas fa-edit text-primary me-2 fa-lg"
                        title="Edit"
                        role="button"
                      ></i>
                    </Link>
                    <i
                      className="fas fa-share text-danger me-2 fa-lg"
                      title="Remove Yourself From Log"
                      role="button"
                      onClick={() => clearShareWith(x.SubmissionId)}
                    ></i>
                  </div>
                </div>
              );
            })}
          </div>
        </ExpandDiv>
      )}
    </div>
  );
}

export default Supervision2;
